import * as Promise from 'es6-promise';
import 'isomorphic-fetch';
import '@babel/polyfill';

Promise.polyfill();
